// src/i18n.js
import Quality from "components/Homepage/Quality";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "footer.description":
        "Learn more about our daily arrivals and how we can help you serve the freshest and most varied fish and seafood to your customers at any time.",
      "footer.enterEmailAddress": "Enter email address",
      "footer.send": "Send",
      "footer.allRightsReserved": "All Rights Reserved",

      "navbar.head1": "Home",
      "navbar.head2": "Product ⌵",
      "navbar.head3": "About",
      "navbar.head4": "Service",
      "navbar.head5": "Contact",
      Quality: "Quality",
      "navbar.enquiry": "Enquiry",

      "contact.head1": "Contact ",

      "home.headblack1": "Reliable",
      "home.headred1": "Partner",
      "home.content1":
        "You can depend on us for consistent, high-quality seafood deliveries, keeping your business running smoothly.",
      "home.headblack2": "Increased",
      "home.headred2": "Efficiency",
      "home.content2":
        "Simplify your sourcing with our one-stop shop for all your seafood needs. Enjoy fresh, high-quality seafood delivered to your door.",
      "home.headblack3": "Enhanced",
      "home.headred3": "Reputation",
      "home.content3":
        "Offer your customers the peace of mind that comes with serving sustainable, responsibly sourced seafood.",

      "home.tabblack1": "Our",
      "home.tabred1": "Product",
      bannercontent1: "Delivering Fresh Seafood ",
      bannercontent2: "Across Canada",
      bannercontent3: "Leading the Way in Sustainable Seafood Distribution",
      homecontent1: "about",
      homecontent2: "our seafood",
      homecontent3: "company",
      homecontent4: "Méditerrane Food",
      homecontent5:
        "We are leading seafood distributor in Canada. We distribute to retail markets, fishmongers, hotels, restaurants and institutions, as well as to manufacturers of ready-to-eat products. Our commitment to sustainable practices and supply chain integrity ensures that our fish reaches consumers around the world.",
      homecontent6: "About Us",
      homecontent7: "WE OFFER FIRST CLASS SEA FOOD",
      homecontent8:
        "We guarantee you the best seafood, delivered daily to our dock, prepared to your liking. Our focus is on serving the absolute freshest fish and seafood.",
      homecontent9: "seafood",
      homecontent10: "PRODUCTS",
      homecontent11: "DISCOVER OUR",
      homecontent12: "Bluefin Tuna GG",
      homecontent13: "Thon",
      homecontent14: "Red Scropionfish",
      homecontent15: "Grey Mullet",
      homecontent16: "Red Mullet",
      homecontent17: "Seabream",
      homecontent18: "Octopus",
      homecontent19: "Seabass",
      homecontent20: "Squid",
      homecontent21: "Whiteleg Shrimp",
      homecontent22: "view More products",
      homecontent23: "CATEGORIES",
      homecontent24: "We Provides Best FRESH Fish",
      homecontent25: "AIRCARGO / FROZEN SEAFOOD- SEAWAY",
      homecontent26:
        "We Provides Best FRESH Fish AIRCARGO / FROZEN SEAFOOD - SEAWAY",
      homecontent27: "Cephalopodes",
      homecontent28: "Farmed Fish",
      homecontent29: "Crustacean",
      homecontent30: "Wild Fish",

      homecontent32: "Get a quote",
      homecontent33: "What Our Client ",
      homecontent34: "say's ",
      homecontent35:
        "This product is amazing! I've seen great results after using it for a few weeks. Highly recommend to everyone. Customer service is also top-notch. This product is amazing! I've seen great results after using it for a few weeks. Highly recommend to everyone. Customer service is also top-notch. ",
      homecontent36: "Customer",
      homecontent37: "Book Your Orders Now",
      homecontent38: "Get In Touch",
      homecontent39:
        "For inquiries, please email us our team will respond promptly to assist you with your needs.",
      homecontent40: "First Name",
      homecontent41: "Last Name",
      homecontent42: "Phone Number",
      homecontent43: "Email",
      homecontent44: "Write your message",
      homecontent45: "Submit",
      homecontent46: "Our priority is quality",
      homecontent47:
        "We attach the quality of our products and the satisfaction of our customers.",
      homecontent48: "215",
      homecontent49: "Complete Projects",
      homecontent50:
        "Successfully accomplished all project with Innovation and Efficiency",
      homecontent51: "123",
      homecontent52: "Expert Employees",
      homecontent53:
        "We have expertise in guaranteeing superior quality for each service.",
      homecontent54: "3245",
      homecontent55: "Satisfied Customers",
      homecontent56: "Improving our skills and expertise to meet your needs.",

      footercontent1:
        "The world’s first marketplace for crypto collectibles and non-fungible tokens",
      footercontent2: "Get Direction",
      footercontent3: " View on map",
      footercontent4: " Opening Hours",
      footercontent5: " Monday",
      footercontent6: " Tuesday",
      footercontent7: " Saturday",
      footercontent8: " Sunday",
      footercontent12: "Administration office, 3418 rue Stanley, R 2, Montréal, Québec, H3A 1R8 Canada",
      contactcontent1: " CONTACT US",
      contactcontent2:
        " Your satisfaction is our ultimate goal. We are dedicated to providing excellent customer service and ensuring that you are happy with every purchase.",
      aboutcontent1: " ABOUT OUR MEDITERRANEE FOOD ",
      aboutcontent2:
        " Our commitment to quality and excellence drives us to produce and deliver products that not only meet but exceed your expectations.",
      aboutcontent3: " about",
      aboutcontent4: " Our",
      aboutcontent5: " Story",
      aboutcontent6: " Méditerrane Food",
      aboutcontent7:
        "  Méditerrane food is a leading seafood distributor in Canada We distribute to retail markets, fishmongers, hotels,restaurants and institutions, as well as to manufacturers of ready-to-eat products. Our buyers scour the globe to unear and find the best breeders, producers, manufacturers and products available to offer you variety and constant availability while maintaining our highest standards of seafood quality.",
      aboutcontent8: " WORKING PROCESS",
      aboutcontent9: " How Our",
      aboutcontent10: " Fishred",
      aboutcontent11: " Works",
      aboutcontent12: " Expert",
      aboutcontent13: " Breeding",
      aboutcontent14:
        " Your trusted partner for high-performance and sustainable farming solutions.",
      aboutcontent15: " Premium",
      aboutcontent16: " Fish",
      aboutcontent17:
        " The guarantee of exceptional quality for your taste buds, safety and freshness.",
      aboutcontent18: " Verified",
      aboutcontent19: " Professionals",
      aboutcontent20:
        "  Vetted professionals for high-quality services and complete peace of mind.",
      aboutcontent21: " Product",
      aboutcontent22: " Quality",
      aboutcontent23:
        " We strive for impeccable quality, focus on high standards and customer satisfaction.",
      aboutcontent24: " Complete projects",
      aboutcontent25: " Expert employee",
      aboutcontent26: " Satisfied customers",
      aboutcontent27: " Convention taken",
      aboutcontent28: " Our Vision",
      aboutcontent29: " Our Mission",
      aboutcontent30: " Our Values",
      aboutcontent31:
        " Our vision is to create a global impact by integrating our highly nutritious Mediterranean fish into the diets of consumers worldwide. By focusing on the exceptional quality of our fish, we aim to offer consumers an optimal source of nutrition to support their well-being and health. Through a strategic expansion of our presence in international markets and strong partnerships with distributors and retailers, we aim to make our Mediterranean fish accessible to a wide audience. Our commitment to sustainable practices and supply chain integrity ensures that our fish reaches consumers around the world in fresh condition and of the highest quality.",
      aboutcontent32:
        " We produce for your well-being and satisfaction To be recognized as the most valuable seafood distributor in the province of Canada. To bring a unique approach to the market by offering unparalleled service, quality products and competitive pricing. We have the solutions",
      aboutcontent33:
        " We are committed to promoting the sustainable development of people by protecting their health and preserving an environment conducive to a good quality of life for future generations. We are aware of the importance of preserving our planet and ensuring a sustainable future for all. That's why we implement environmentally-friendly practices, minimizing our ecological footprint and promoting sustainable production methods",

      servicecontent1: " Our services",
      servicecontent2:
        " We are the leading importer and distributor of diverse food products. With years of experience in the industry, we have built strong relationships with reputable suppliers worldwide.",
      servicecontent3: " The Most Valued Seafood Distributor",
      servicecontent4:
        " Competitive pricing, superior quality, along with excellence in delivery and service",
      servicecontent5: " Global Sourcing",
      servicecontent6:
        " We have established strong relationships with trusted suppliers worldwide, allowing us to source a diverse range of food products!",
      servicecontent7: "View more ﹥",
      servicecontent8: "Import Expertise",
      servicecontent9:
        "Our expertise in customs regulations, documentation ensures a seamless import , delivering your products on time and in perfect condition.",
      servicecontent10: "Distribution Network",
      servicecontent11:
        "We use storage and transportation solutions to maintain the freshness and quality of our products from the moment they arrive  to your doorstep.",
      servicecontent12: "Fresh Produce",
      servicecontent13:
        " Our produce is carefully selected and transported under optimal conditions to preserve its freshness and nutritional value.",
      servicecontent14: "Extensive Range",
      servicecontent15:
        "From fresh produce and dairy to specialty and ethnic foods, our product range caters to diverse culinary preferences.",
      servicecontent16: "Quality Assurance",
      servicecontent17:
        "Our rigorous quality control processes guarantee that every product meets the highest standards of safety and excellence",
      servicecontent18: "Importing and Distributing Foodstuffs",
      servicecontent19:
        "We specialize in importing and distributing high-quality foodstuffs from around the globe. Our mission is to bring the finest and freshest products to your table, ensuring a delightful culinary experience for all our customers.",
      servicecontent20: " Wide Variety",
      servicecontent21: " High quality foodstuffs",
      servicecontent22: " Premium Quality",
      servicecontent23: "  Safe & highest quality",
      qualitycontent1: " ROYAL BREAM",
      qualitycontent2:
        " This type of fish is recognizable by the dark spot at the origin of its lateral line, the black line along its dorsal fin and its golden crown.",
      qualitycontent3: " ROYAL DURADE",
      qualitycontent4: " Nutritional Value",
      qualitycontent5: " Family : Sparidae",
      qualitycontent6: " Order : Perciformes",
      qualitycontent7: " Gender : Sparus",
      qualitycontent8: " Species : Aurata",
      qualitycontent9: " Ash (%) : 1.79",
      qualitycontent10: " Humidity (%) : 70.49",
      qualitycontent11: " Protein (g/100g) : 19.24",
      qualitycontent12: " Total lipids (g/100g) : 7.53",
      qualitycontent13: "Saturated AG (g/100g) : 1.59",
      qualitycontent14: " Monounsaturated fatty acids (g/100g) : 3.057",
      qualitycontent15:
        " Polyunsaturated fatty acids (g/100g): 2.836 : Of which omega 6 (g/100g): 1.437 , Of which omega 3 (g/100g): 1,399",
      qualitycontent16: "Features",
      qualitycontent17: "Lead : 0.3 mg/kg wet weight",
      qualitycontent18: "Mercury : 1 mg/kg wet weight",
      qualitycontent19: "Cadmium : 0.05 mg/kg fresh weight",
      qualitycontent20: "PAH (Benzo(a) pyrene) : 2 µg/kg fresh weight",
      qualitycontent21:
        "Sum of dioxins : (WHO-PCDD/F-TEQ):4.0 pg/g fresh weight",
      qualitycontent22:
        "ABVT (Total volatile basic nitrogen) : 25 mg ABVT/100g of flesh",
      qualitycontent23:
        " Sum of dioxins and dioxin-like PCBs WHO- : PCDD/F-PCB-TEQ:8.0 pg/g fresh weight",
      qualitycontent24:
        " Physical & Biological characteristics : Free from foreign bodies , Salmonella Absence in 25 g , E. coli , Coagulase-positive staphylococci , Aerobic microorganisms at 30°C",

      qualitycontent50: "    Distribution Method and Duration",
      qualitycontent51:
        "    This product is intended for various culinary preparations (grilling, cooking, etc.) Shelf life and storage conditions: Store in refrigerated rooms at a temperature between 0°C and 2°C Use-by date (UBD): 10 days from the date of fishing",
      qualitycontent52: "    Weight",
      qualitycontent53: "    Between 300g and 1000g",
      qualitycontent54: "    Farmed Fish",
      qualitycontent55:
        "    In the Mediterranean Sea: (FAO fishing zone: 37.2.2) in Tunisia",
      qualitycontent56: "    Intended Use",
      qualitycontent57:
        "    This product is intended for various culinary preparations (grilling, cooking, etc.)",
      qualitycontent58: "    Regulatory References",
      qualitycontent59:
        "    Order of the Minister of Agriculture, Water Resources and Fisheries of March 26, 2010, amending and supplementing the order of September 19, 1998, establishing the procedures for  health control and monitoring of the conditions of production of fishery products and their placing on the market.",
      qualitycontent60:
        "    Regulatory requirements for the official control of certain contaminants in foodstuffs “Maximum limits, methods of sampling and analysis of samples” Joint Order of 13 May 2013. JORT No. 44.",

      qualitycontent61:
        "   Commission regulation (EC) No 1881/2006 of 19 December 2006 setting maximum levels for certain contaminants in foodstuffs",

      qualitycontent62: "  VIEW PRODUCT",
      qualitycontent63: "  Packaging Method",
      qualitycontent64:
        "  The product is packaged in primary packaging (food grade plastic bag) then in secondary packaging (polystyrene boxes), The product must bear the following labelling information:Fish raised in the Mediterranean Sea batch number: (reticule no./cage no./supplier/stocking date/fishing date)",
      qualitycontent65:
        "  The fishing zone according to FAO , The name of the establishment , the address of the establishment, the origin, the health approval number , The date of fishing.",
      qualitycontent66:
        "  The DLC , The name of the fish species name in French, in Latin , conditions of use and/or storage: “store under ice at a temperature between 0°C and 2°C” , the destinationcountry , The weight , The caliber",
      foodcontent1: "  FRESH PRODUCTS",
      foodcontent2:
        "  With daily arrivals, you are sure to be able to serve fresh and varied fish and seafood to your customers at any time",
      foodcontent3: "  Our Featured",
      foodcontent4: "  Farmed Fish",
      foodcontent5: "  Daurade",
      foodcontent6: "  400/600Grm",
      foodcontent7: "  Seabream",
      foodcontent8: "  Loup de mer/bar",
      foodcontent9: "  400Grm/600Grm",
      foodcontent10: "  Seabass",
      foodcontent11: "  Thon Rouge",
      foodcontent12: "  100/500Kg",
      foodcontent13: "  Bluefin Tuna GG",
      foodcontent14: "  Thon Rouge",
      foodcontent15: "  100/500Kg",
      foodcontent16: "  Bluefin Tuna Loins",
      foodcontent17: "  Loup de Mer/Bar",
      foodcontent18: "   400/600Grm",
      foodcontent19: "   Merou Royal",
      foodcontent20: "   1Kg/30Kg",
      foodcontent21: "    Mottled Grouper",
      foodcontent22: "     Our Featured",
      foodcontent23: "     Wild Fish",
      foodcontent24: "     Rascasse",
      foodcontent25: "     500Grm/1Kg",
      foodcontent26: "      Wild Fish",
      foodcontent27: "      Red Scorpionfish",
      foodcontent28: "      Petite Roussette",
      foodcontent29: "      0.5Kg/3Kg",
      foodcontent30: "      Spotted Catshark",
      foodcontent31: "      Rouget",
      foodcontent32: "      50Grm/90Grm",
      foodcontent33: "      Red Mullet",
      foodcontent34: "      Pagre",
      foodcontent35: "      1Kg/10Kg",
      foodcontent36: "      Seabream",
      foodcontent37: "      Rascasse",
      foodcontent38: "       500Grm/1Kg",
      foodcontent39: "       Red Scorpion Fish",
      foodcontent40: "       Merou",
      foodcontent41: "       1Kg/30Kg",
      foodcontent42: "       Mottled Grouper",
      foodcontent43: "      Bonite",
      foodcontent44: "       1Kg/5Kg",
      foodcontent45: "       Bonito",
      foodcontent46: "        Espadon",
      foodcontent47: "        5Kg/30Kg",
      foodcontent48: "        SwordFish",
      foodcontent49: "        Sardine",
      foodcontent50: "        12Kg/25Kg",
      foodcontent51: "        Pilchard",
      foodcontent52: "        Merou Blanc",
      foodcontent53: "        1Kg/30Kg",
      foodcontent54: "        White Grouper",
      foodcontent55: "        Mulet",
      foodcontent56: "        3/4 PPK",
      foodcontent57: "        Grey Mullet",
      foodcontent58: "        Little Tunny",
      foodcontent59: "         1Kg/5Kg",
      foodcontent60: "         Thon",
      foodcontent61: "         Our Featured",
      foodcontent62: "         Cephalopodes",
      foodcontent63: "         Poulpe",
      foodcontent64: "         300Grm/3Kg",
      foodcontent65: "         Octopus",
      foodcontent66: "         Seiche",
      foodcontent67: "         300Grm/1Kg",
      foodcontent68: "         Cuttle Fish",
      foodcontent69: "           Calamar",
      foodcontent70: "           300Grm/1Kg",
      foodcontent71: "           Squid",
      foodcontent72: "           Calamar",
      foodcontent73: "           300Grm/1Kg",
      foodcontent74: "           Crustacean",
      foodcontent75: "           Crevette Pattes Blanches",
      foodcontent76: "           20/30PPK",
      foodcontent77: "           Whiteleg Shrimp",
      headercontent1: "           Cephalopodes",
      headercontent2: " Octopuses, squids, and cuttlefish",
      headercontent3: " Crustacean",
      headercontent4: " Whiteleg Shrimp, squids, cuttlefish",
      headercontent5: " Farmed Fish",
      headercontent6: " Seabream, seabass, bluefin tuna",
      headercontent7: " Red mullet, bonito, swordfish",
    },
  },
  fr: {
    translation: {
      "footer.description":
        "Apprenez-en davantage sur nos arrivages quotidiens et sur la façon dont nous pouvons vous aider à servir à tout moment les poissons et fruits de mer les plus frais et les plus variés à vos clients.",
      "footer.enterEmailAddress": "Entrer l'adresse e-mail",
      "footer.send": "Envoyer",
      "footer.allRightsReserved": "Tous droits réservés",

      "navbar.head1": "Accueil",
      "navbar.head2": "Produit ⌵",
      "navbar.head3": "À propos",
      "navbar.head4": "Galerie",
      "navbar.head5": "contactez",
      "navbar.enquiry": "Demande",
      Quality: "Qualité",

      "contact.head1": "Contact Usss",

      "home.headblack1": "grand nombre de",
      "home.headred1": "produits",
      "home.content1":
        "Notre entreprise propose une large gamme de produits aquacoles pour répondre à tous vos besoins de production.",
      "home.headblack2": "grand nombre de",
      "home.headred2": "Clientèle",
      "home.content2":
        "Depuis de nombreuses années, nous travaillons à améliorer nos compétences et à élargir notre champ d'expertise.",
      "home.headblack3": "Produits de qualité",
      "home.headred3": "Distribué",
      "home.content3":
        "Pour la fraîcheur et des prix compétitifs, distribuer les produits que vous souhaitez chaque jour au meilleur prix.",
      bannercontent1: "Livraison de fruits de mer frais ",
      bannercontent2: "Partout au Canada",
      bannercontent3:
        "Ouvrir la voie en matière de distribution durable de fruits de mer",
      homecontent1: "à propos",
      homecontent2: "nos fruits de mer",
      homecontent3: "entreprise",
      homecontent4: "Alimentation Méditerranéenne",
      homecontent5:
        "Nous sommes le principal distributeur de produits de la mer au Canada. Nous distribuons aux marchés de détail, aux poissonneries, aux hôtels, aux restaurants et aux institutions, ainsi qu'aux fabricants de produits prêts-à-manger. Notre engagement envers des pratiques durables et l'intégrité de la chaîne d'approvisionnement garantit que notre poisson atteint consommateurs du monde entier.",
      homecontent6: "À propos de nous",
      homecontent7: "NOUS PROPOSONS DES FRUITS DE MER DE PREMIÈRE CLASSE",
      homecontent8:
        "Nous vous garantissons les meilleurs fruits de mer, livrés quotidiennement à notre quai, préparés à votre goût. Notre objectif est de servir les poissons et fruits de mer les plus frais.",
      homecontent9: "fruit de mer",
      homecontent10: "DES PRODUITS",
      homecontent11: "DÉCOUVREZ NOTRE",
      homecontent12: "Thon Rouge GG",
      homecontent13: "Thôn",
      homecontent14: "Poisson-scropion rouge",
      homecontent15: "Mulet gris",
      homecontent16: "Rouget",
      homecontent17: "Daurade",
      homecontent18: "Pieuvre",
      homecontent19: "Bar",
      homecontent20: "Calmar",
      homecontent21: "Crevettes à pattes blanches",
      homecontent22: "voir Plus de produits",
      homecontent23: "CATÉGORIES",
      homecontent24: "Nous fournissons le meilleur poisson FRAIS",
      homecontent25: "CARGO AÉRIEN / FRUITS DE MER SURGELÉS - VOIE MARITIME",
      homecontent26:
        "Nous fournissons le meilleur poisson FRAIS CARGO AÉRIEN / FRUITS DE MER SURGELÉS - SEAWAY",
      homecontent27: "Céphalopodes",
      homecontent28: "Poisson d'élevage",
      homecontent29: "Crustacée",
      homecontent30: "Poisson sauvage",

      homecontent32: "obtenir un devis",
      homecontent33: "Ce que notre client ",
      homecontent34: "dit ",
      homecontent35:
        "Ce produit est incroyable ! J'ai vu d'excellents résultats après l'avoir utilisé pendant quelques semaines. Je le recommande vivement à tout le monde. Le service client est également de premier ordre. Ce produit est incroyable ! J'ai vu d'excellents résultats après l'avoir utilisé pendant quelques semaines. Je le recommande vivement à tout le monde. Le service client est également de premier ordre. ",
      homecontent36: "cliente",
      homecontent37: "Réservez vos commandes maintenant",
      homecontent38: "Entrer en contact",
      homecontent39:
        "Pour toute demande de renseignements, veuillez nous envoyer un e-mail, notre équipe vous répondra rapidement pour vous aider à répondre à vos besoins.",
      homecontent40: "Prénom",
      homecontent41: "Nom de famille",
      homecontent42: "Numéro de téléphone",
      homecontent43: "E-mail",
      homecontent44: "Écrivez votre message",
      homecontent45: "Soumettre",
      homecontent46: "Notre priorité est la qualité",
      homecontent47:
        "Nous attachons la qualité de nos produits et la satisfaction de nos clients.",
      homecontent48: "215",
      homecontent49: "Projets terminés",
      homecontent50:
        "Réalisation réussie de tous les projets avec innovation et efficacité",
      homecontent51: "123",
      homecontent52: "Employés experts",
      homecontent53:
        "Nous avons l’expertise nécessaire pour garantir une qualité supérieure pour chaque service.",
      homecontent54: "3245",
      homecontent55: "Clients satisfaits",
      homecontent56:
        "Améliorer nos compétences et notre expertise pour répondre à vos besoins.",

      footercontent1:
        "Le premier marché au monde pour les objets de collection cryptographiques et les jetons non fongibles",
      footercontent2: "Obtenir une direction",
      footercontent3: " Voir sur la carte",
      footercontent4: " Horaires d'ouvertures",
      footercontent5: " Lundi",
      footercontent6: " Mardi",
      footercontent7: " Samedi",
      footercontent12: " Bureau administratif, 3418, rue Stanley, R 2, Montréal (Québec) H3A 1R8, Canada",
      contactcontent1: " CONTACTEZ-NOUS",
      contactcontent2:
        " Votre satisfaction est notre but ultime. Nous nous engageons à fournir un excellent service client et à garantir que vous êtes satisfait de chaque achat.",
      aboutcontent1: " À PROPOS DE NOTRE CUISINE MÉDITERRANÉENNE",
      aboutcontent2:
        " Notre engagement envers la qualité et l’excellence nous pousse à produire et à livrer des produits qui non seulement répondent mais dépassent vos attentes.",
      aboutcontent3: " à propos",
      aboutcontent4: " Notre",
      aboutcontent5: " Histoire",
      aboutcontent6: " Méditerrane Food",
      aboutcontent7:
        "  Méditerrane food est un important distributeur de produits de la mer au Canada. Nous distribuons aux marchés de détail, aux poissonneries, aux hôtels, aux restaurants et aux institutions, ainsi qu'aux fabricants de produits prêts-à-manger. Nos acheteurs parcourent le monde pour dénicher et trouver les meilleurs éleveurs, producteurs, fabricants et produits disponibles pour vous offrir une variété et une disponibilité constante tout en maintenant nos plus hauts standards de qualité des fruits de mer.",
      aboutcontent8: " PROCESSUS DE TRAVAIL",
      aboutcontent9: " Comment notre",
      aboutcontent10: " Pêche",
      aboutcontent11: " Travaux",
      aboutcontent12: " Experte",
      aboutcontent13: " Reproduction",
      aboutcontent14:
        " Votre partenaire de confiance pour des solutions agricoles performantes et durables.",
      aboutcontent15: " Prime",
      aboutcontent16: " Poisson",
      aboutcontent17:
        " La garantie d'une qualité exceptionnelle pour vos papilles, de sécurité et de fraîcheur.",
      aboutcontent18: " Vérifié",
      aboutcontent19: " Professionnelles",
      aboutcontent20:
        "  Des professionnels agréés pour des services de haute qualité et une totale tranquillité d'esprit.",
      aboutcontent21: " Produit",
      aboutcontent22: " Qualité",
      aboutcontent23:
        "Nous visons une qualité irréprochable, nous concentrons sur des normes élevées et la satisfaction du client..",
      aboutcontent24: " Projets terminés",
      aboutcontent25: " Employé expert",
      aboutcontent26: " Clients satisfaits",
      aboutcontent27: " Convention prise",
      aboutcontent28: " Notre vision",
      aboutcontent29: " Notre mission",
      aboutcontent30: " Nos valeurs",
      aboutcontent31:
        " Notre vision est de créer un impact mondial en intégrant notre poisson méditerranéen hautement nutritif dans l'alimentation des consommateurs du monde entier. En mettant l'accent sur la qualité exceptionnelle de nos poissons, nous visons à offrir aux consommateurs une source nutritionnelle optimale pour soutenir leur bien-être et leur santé. Grâce à une expansion stratégique de notre présence sur les marchés internationaux et à des partenariats solides avec des distributeurs et des détaillants, nous visons à rendre nos poissons méditerranéens accessibles à un large public. Notre engagement envers des pratiques durables et l'intégrité de la chaîne d'approvisionnement garantit que notre poisson parvient aux consommateurs du monde entier frais et de la plus haute qualité.",
      aboutcontent32:
        " Nous produisons pour votre bien-être et votre satisfaction. Être reconnu comme le distributeur de fruits de mer le plus précieux de la province du Canada. Apporter une approche unique au marché en offrant un service inégalé, des produits de qualité et des prix compétitifs. Nous avons les solutions.",
      aboutcontent33:
        " Nous nous engageons à promouvoir le développement durable des personnes en protégeant leur santé et en préservant un environnement propice à une bonne qualité de vie pour les générations futures. Nous sommes conscients de l’importance de préserver notre planète et d’assurer un avenir durable pour tous. C'est pourquoi nous mettons en œuvre des pratiques respectueuses de l'environnement, minimisant notre empreinte écologique et promouvant des méthodes de production durables.",

      servicecontent1: " Nos services",
      servicecontent2:
        " nous sommes le principal importateur et distributeur de produits alimentaires divers. Avec des années d’expérience dans l’industrie, nous avons bâti des relations solides avec des fournisseurs réputés dans le monde entier.",
      servicecontent3: " Le distributeur de fruits de mer le plus apprécié",
      servicecontent4:
        " Prix ​​compétitifs, qualité supérieure, ainsi que l'excellence de la livraison et du service",
      servicecontent5: " L'approvisionnement mondial",
      servicecontent6:
        " Nous avons établi des relations solides avec des fournisseurs de confiance dans le monde entier, ce qui nous permet de nous approvisionner en une gamme diversifiée de produits alimentaires !",
      servicecontent7: "Voir plus ﹥",
      servicecontent8: "Expertise en importation",
      servicecontent9:
        "Notre expertise en matière de réglementation douanière, de documentation garantit une importation fluide, livrant vos produits à temps et en parfait état.",
      servicecontent10: "Réseau de distribution",
      servicecontent11:
        "Nous utilisons des solutions de stockage et de transport pour maintenir la fraîcheur et la qualité de nos produits dès leur arrivée à votre porte.",
      servicecontent12: "Produits frais",
      servicecontent13:
        " Nos produits sont soigneusement sélectionnés et transportés dans des conditions optimales pour préserver leur fraîcheur et leur valeur nutritionnelle.",
      servicecontent14: "Grande portée",
      servicecontent15:
        "Des produits frais et laitiers aux aliments spécialisés et ethniques, notre gamme de produits répond à diverses préférences culinaires.",
      servicecontent16: "Assurance qualité",
      servicecontent17:
        "Nos processus rigoureux de contrôle de qualité garantissent que chaque produit répond aux normes de sécurité et d'excellence les plus élevées.",
      servicecontent18: "Importation et distribution de produits alimentaires",
      servicecontent19:
        "nous sommes spécialisés dans l’importation et la distribution de produits alimentaires de haute qualité en provenance du monde entier. Notre mission est d'apporter les produits les plus fins et les plus frais à votre table, garantissant ainsi une expérience culinaire délicieuse à tous nos clients.",
      servicecontent20: " Grande variété",
      servicecontent21: " produits alimentaires de haute qualité",
      servicecontent22: " Qualité supérieure ",
      servicecontent23: " sûr et de la plus haute qualité",
      qualitycontent1: " BRÈME ROYALE ",
      qualitycontent2:
        " Ce type de poisson est reconnaissable à la tache sombre à l'origine de sa ligne latérale, à la ligne noire le long de sa nageoire dorsale et à sa couronne dorée.",
      qualitycontent3: " DURADE ROYALE",
      qualitycontent4: " La valeur nutritionnelle",
      qualitycontent5: " Famille : Sparidés",
      qualitycontent6: " Ordre : Perciformes",
      qualitycontent7: " Sexe: Sparus",
      qualitycontent8: " Espèce : Aurate",
      qualitycontent9: " Cendres (%) : 1,79",
      qualitycontent10: " Humidité (%) : 70,49",
      qualitycontent11: " Protéines (g/100g) : 19,24",
      qualitycontent12: " Lipides totaux (g/100g) : 7,53",
      qualitycontent13: "AG saturé (g/100g) : 1,59",
      qualitycontent14: "Acides gras monoinsaturés (g/100g) : 3.057",
      qualitycontent15:
        " Acides gras polyinsaturés (g/100g) : 2,836 : Dont oméga 6 (g/100g) : 1,437 , Dont oméga 3 (g/100g) : 1,399",
      qualitycontent16: "Caractéristiques",
      qualitycontent17: "Plomb : 0,3 mg/kg poids humide",
      qualitycontent18: "Mercure : 1 mg/kg poids humide",
      qualitycontent19: "Cadmium : 0,05 mg/kg poids frais",
      qualitycontent20: "HAP (Benzo(a)pyrène) : 2 µg/kg poids frais",
      qualitycontent21:
        "Somme des dioxines : (WHO-PCDD/F-TEQ) :4,0 pg/g poids frais",
      qualitycontent22:
        "ABVT (Azote Basique Volatil Total) : 25 mg ABVT/100g de chair",
      qualitycontent23:
        " Somme des dioxines et PCB de type dioxine OMS- : PCDD/F-PCB-TEQ:8,0 pg/g poids frais",
      qualitycontent24:
        " Caractéristiques physiques et biologiques : Exempt de corps étrangers , Absence de Salmonelles dans 25 g , E. coli , Staphylocoques à coagulase positive , Microorganismes aérobies à 30°C",

      qualitycontent50: "    Mode de distribution et durée",
      qualitycontent51:
        "    Ce produit est destiné à diverses préparations culinaires (grillades, cuisson...) Durée de conservation et conditions de conservation : A conserver dans une pièce réfrigérée à une température comprise entre 0°C et 2°C Date limite de consommation (UBD) : 10 jours à compter de la date de pêche",
      qualitycontent52: "    Poids",
      qualitycontent53: "    Entre 300g et 1000g",
      qualitycontent54: "    Poisson d'élevage",
      qualitycontent55:
        "    En mer Méditerranée : (zone de pêche FAO : 37.2.2) en Tunisie",
      qualitycontent56: "    Utilisation prévue",
      qualitycontent57:
        "    Ce produit est destiné à diverses préparations culinaires (grillades, cuisson...)",
      qualitycontent58: "   Références réglementaires",
      qualitycontent59:
        "    Arrêté du ministre de l'agriculture, de l'hydraulique et de la pêche du 26 mars 2010 modifiant et complétant l'arrêté du 19 septembre 1998 fixant les modalités de contrôle sanitaire et de surveillance des conditions de production des produits de la pêche et de leur mise sur le marché .",
      qualitycontent60:
        "   Exigences réglementaires relatives au contrôle officiel de certains contaminants dans les denrées alimentaires « Limites maximales, méthodes de prélèvement et d'analyse des échantillons » Arrêté conjoint du 13 mai 2013. JORT n° 44.",
      qualitycontent61:
        "   RÈGLEMENT (CE) N° 1881/2006 DE LA COMMISSION du 19 décembre 2006 fixant des teneurs maximales pour certains contaminants dans les denrées alimentaires",
      qualitycontent62: "  Voir le produit",
      qualitycontent63: "  Méthode d'emballage",
      qualitycontent64:
        "  Le produit est conditionné dans un emballage primaire (sachet plastique alimentaire) puis dans un emballage secondaire (boîtes en polystyrène), Le produit doit porter les informations d'étiquetage suivantes :Poissons élevés en Méditerranée numéro de lot : (n° de réticule/n° de cage/fournisseur /date d'empoissonnement/date de pêche)",
      qualitycontent65:
        " la zone de pêche selon la FAO , Le nom de l'établissement , l'adresse de l'établissement, l'origine, le numéro d'agrément sanitaire , La date de pêche.",
      qualitycontent66:
        "  Le DLC , Le nom de l'espèce de poisson en français, en latin , les conditions d'utilisation et/ou de stockage : « conserver sous glace à une température comprise entre 0°C et 2°C » , le pays de destination , Le poids , Le calibre",
      foodcontent1: "  PRODUITS FRAIS",
      foodcontent2:
        "  Avec des arrivages quotidiens, vous êtes assuré de pouvoir servir à tout moment des poissons et fruits de mer frais et variés à vos clients.",
      foodcontent3: "  Notre vedette",
      foodcontent4: "  poisson d'élevage",
      foodcontent5: "  Daurade",
      foodcontent7: "  Daurade",
      foodcontent8: "  Loup de mer/bar",
      foodcontent9: "  400Grm/600Grm",
      foodcontent10: "  Bar",
      foodcontent11: "  Thon Rouge",
      foodcontent12: "  100/500Kg",
      foodcontent13: "  Thon Rouge GG",
      foodcontent14: "  Thon Rouge",
      foodcontent15: "  100/500Kg",
      foodcontent16: "  Longes de thon rouge",
      foodcontent17: "  Loup de Mer/Bar",
      foodcontent18: "   400/600Grm",
      foodcontent19: "   Mérou Royal",
      foodcontent20: "   1Kg/30Kg",
      foodcontent21: "    Mérou tacheté",
      foodcontent22: "    Notre vedette",
      foodcontent23: "     poisson sauvage",
      foodcontent24: "     Rascassé",
      foodcontent25: "     500Grm/1Kg",
      foodcontent26: "      Poisson sauvage",
      foodcontent27: "      Poisson-scorpion rouge",
      foodcontent28: "      Petite Roussette",
      foodcontent29: "      0.5Kg/3Kg",
      foodcontent30: "      Requin-chat en pot",
      foodcontent31: "      Rouget",
      foodcontent32: "      50Grm/90Grm",
      foodcontent33: "     Rouget",
      foodcontent34: "      Page",
      foodcontent35: "      1Kg/10Kg",
      foodcontent36: "      Daurade",
      foodcontent37: "      Rascassé",
      foodcontent38: "       500Grm/1Kg",
      foodcontent39: "       Poisson scorpion rouge",
      foodcontent40: "       Mérou",
      foodcontent41: "       1Kg/30Kg",
      foodcontent42: "       Mérou tacheté",
      foodcontent43: "      Bonite",
      foodcontent44: "       1Kg/5Kg",
      foodcontent45: "       Bonito",
      foodcontent46: "        Espadon",
      foodcontent47: "        5Kg/30Kg",
      foodcontent48: "        Espadon",
      foodcontent49: "        Sardine",
      foodcontent50: "        12Kg/25Kg",
      foodcontent51: "        Pilchard",
      foodcontent52: "        Merou Blanc",
      foodcontent53: "        1Kg/30Kg",
      foodcontent54: "        Mérou blanc",
      foodcontent55: "        Nuageux",
      foodcontent56: "        3/4 PPK",
      foodcontent57: "       Mulet gris",
      foodcontent58: "        Petit thon",
      foodcontent59: "         1Kg/5Kg",
      foodcontent60: "         Thôn",
      foodcontent61: "         Notre vedette",
      foodcontent62: "        Céphalopodes",
      foodcontent63: "         Poulpe",
      foodcontent64: "         300Grm/3Kg",
      foodcontent65: "         Pieuvre",
      foodcontent66: "         Seiche",
      foodcontent67: "         300Grm/1Kg",
      foodcontent68: "         Seiche",
      foodcontent69: "        Calmar",
      foodcontent70: "           300Grm/1Kg",
      foodcontent71: "           Squid",
      foodcontent72: "           Calmar",
      foodcontent73: "           300Grm/1Kg",
      foodcontent74: "           Crustacée",
      foodcontent75: "          Crevette Pattes Blanches",
      foodcontent76: "           20/30PPK",
      foodcontent77: "           Crevettes à pattes blanches",
      headercontent1: "           Céphalopodes",
      headercontent2: " Poulpes, calamars et seiches",
      headercontent3: " Crustacée",
      headercontent4: " Crevettes à pattes blanches, calamars, seiches",
      headercontent5: " Poisson d'élevage",
      headercontent6: " Daurade, bar, thon rouge",
      headercontent7: " Rouget, bonite, espadon",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
